









import {Component, Prop, Vue} from 'vue-property-decorator'
import IconCustom from '@/components/lib/IconCustom.vue'
import {IOption} from '@/components/lib/models'

@Component({
  components: {
    IconCustom
  }
})
export default class InputToggleItem extends Vue {
  @Prop({ default: false }) readonly selected?: boolean
  @Prop({ default: false }) readonly custom?: boolean
  @Prop() readonly data!: IOption<string>

  get fill(): string {
    // return this.selected ? 'ui-input-fill' : 'ui-contrast';
    return this.selected ? 'ui-input-fill' : 'accent';
  }

  private select(): void {
    (this.$refs['native'] as HTMLElement)?.focus();
    this.$emit('click');
  }

}
